import { render } from "./CxSimplePopup.vue?vue&type=template&id=1bf54ade"
import script from "./CxSimplePopup.vue?vue&type=script&lang=js"
export * from "./CxSimplePopup.vue?vue&type=script&lang=js"

import "./CxSimplePopup.vue?vue&type=style&index=0&id=1bf54ade&lang=less"

import exportComponent from "/home/ec2-user/workspace/_ui2_staging_ui2-staging-0.124.0/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__